<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
     <option value=""> {{ firstOption }} </option>
    <option
      v-for="type in selects"
      :key="type.id"
      :value="type.id"
      :selected="type.id == selected"
      >{{ type.index }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectContractReadjustmentIndex',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : '',
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/customer/contract/readjustment-index`)
        .then((res) => {
          this.selects = res.data
      });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
